
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-studio/overview",
      function () {
        return require("private-next-pages/ad-studio/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-studio/overview"])
      });
    }
  